import { useEffect } from "react";
import { useNavigate, useLocation } from "react-router-dom";
import Button from "src/components/Button";
import Modal from "src/components/Modal";
import Input from "src/components/form/Input";
import Form from "src/components/forms/TaskForm/Form";
import withTranslation, {
	Translation,
} from "src/components/hoc/withTranslation";
import useTaskForm from "src/hooks/api/tasks/useTaskForm";
import useTaskScheme from "src/hooks/schemes/useTaskScheme";
import useQueryString from "src/hooks/useQueryString";

interface TaskFormTitleModalProps extends Translation {}

const TaskFormTitleModal = ({ t }: TaskFormTitleModalProps) => {
	const qs = useQueryString();
	const navigate = useNavigate();
	const location = useLocation();
	const { task, actions, status } = useTaskForm();
	const scheme = useTaskScheme();
	const visible = qs?.modal === "create-extern-task";

	useEffect(() => {
		if (visible) {
			actions.clear();
		}
		// eslint-disable-next-line react-hooks/exhaustive-deps
	}, [visible]);

	const onClose = () => {
		actions.clear();
		const root = location.pathname;
		const sp = new URLSearchParams(location.search);
		sp.delete("modal");
		navigate(`${root}${sp ? `?${sp.toString()}` : ""}`);
	};

	return (
		<Modal size={"default"} {...{ onClose, visible }} title={t("title")}>
			<Form
				onSubmit={async () => {
					if (!task.title) {
						return;
					}
					actions.createByTitle(task.title);
				}}
				value={{
					title: task?.title,
				}}
				schema={() => ({
					title: scheme.title,
				})}
				nextButtonLabel="Doorgaan"
				customButtons={
					<>
						<Button
							loading={status !== "idle"}
							disabled={!task.title}
							submit
							className="flex-1 mt-6"
						>
							{t("buttons.continue")}
						</Button>
					</>
				}
			>
				{(getInputProps) => {
					return (
						<>
							<Input
								autoFocus
								label={t("fields.title.label")}
								placeholder={t("fields.title.placeholder")}
								name="title"
								{...getInputProps("title")}
							/>
						</>
					);
				}}
			</Form>
		</Modal>
	);
};

TaskFormTitleModal.locale = {
	nl: {
		title: "Opdracht aanmaken",
		fields: {
			title: {
				label: "Opdracht",
				placeholder: "Bijvoorbeeld: Social media beheren",
			},
		},
		buttons: {
			continue: "Doorgaan",
		},
	},
	en: {
		title: "Create task",
		fields: {
			title: {
				label: "Task",
				placeholder: "Example: Social media management",
			},
		},
		buttons: {
			continue: "Continue",
		},
	},
};

export default withTranslation(TaskFormTitleModal);
